import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

interface ApproveBatchEnrollmentInvitationParams {
  invitationId: string;
}

export const approveBatchEnrollmentInvitation = createAsyncThunk<
  void,
  ApproveBatchEnrollmentInvitationParams,
  { extra: Partial<Dependencies> }
>("admin/batchEnrollmentInvitation/approve", async ({ invitationId }, { extra: { adminRepository } }) => {
  await adminRepository!.approveBatchEnrollmentInvitation(invitationId);
});

export const resetApproveBatchEnrollmentInvitation = createAction("admin/batchEnrollmentInvitation/resetApprove");
